<template>
  <section class="mt-3"  id="chart">
    <div id="chart1">
      <div v-for="(chart, i) in charts" :key="i">
        <h4 v-if="chart.title">{{ chart.title }}</h4>
        <apexchart v-if="show" type="bar" height="400" :options="chart.options" :series="chart.series"></apexchart>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
var moment = require('moment');

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

let instance = null

export default {
  name: 'BarChart',
  props: ['filter', 'loading', 'isNeedUpdate'],

  created() {
    instance = this
    this.reload()
  },

  data() {
    return {
      show: false,
      split: false,
      charts: [],
      colors: this.$store.state.colors,
      yaxisDefault: {
        axisTicks: {
          show: true,
        },
        title: {
          text: "kW",
        },
        tooltip: {
          enabled: false
        }
      },
      splitButton: {
        icon: 'Split',
        class: 'chart-button btn btn-primary',
        title: 'Split',
        index: 0,
        click: function () {
          instance.split = true
          instance.reload()
        }
      },
      mergeButton: {
        icon: 'Aggrega',
        class: 'chart-button btn btn-success',
        title: 'Aggrega',
        index: 0,
        click: function () {
          instance.split = false
          instance.reload()
        }
      },
      options: {
        chart: {
          id: 'column-chart',
          group: 'channels',
          animations: {
            enabled: false
          },
          locales: this.getChartsLocales(),
          defaultLocale: "it",
          toolbar: {
              tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: false,
                  zoomout: false,
                  pan: false,
                  reset: true,
                  customIcons: []
              }
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: 'flat',
            columnWidth: '90%',
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
            width: 4
          },
        xaxis: {
          type: 'datetime',
        },
        yaxis: [
          {
            seriesName: 'data-0',
            axisBorder: {
              show: true,
            },
            axisTicks: {
              show: true,
            },
            title: {
              text: "kW",
            },
            tooltip: {
              enabled: false
            }
          }
        ]
      },
      series: []
    }
  },

  methods: {
    reload() {
      if (this.loading) {
        return;
      }

      if(this.filter.channels.length) {

        if(this.loading != 'silent')
          this.$store.commit("loading")

        this.$store.dispatch('charts/get', this.filter).then( (data) => {
          let series = []
          this.charts = []

          let options = _.cloneDeep(this.options)
          options.colors = this.colors
          options.chart.type = data.parameters.length ? 'line' : 'bar'

          if(this.filter.sampling == 'm') {
            options.xaxis.type = 'category'
            options.xaxis.categories = []
            options.xaxis.categories = data.values.map( v => {
              return moment(v[0]).format('MMM YY')
            })
          } else {
            options.xaxis.type = 'datetime'
          }

          data.columns.forEach( (c, i) => {
            if(i == 0)
              return

            let serie = {
              name: c,
              type: 'column',
              data: data.values.map( v => {
                let serieValue = v[i] ? parseFloat(v[i]) : null
                if(this.filter.sampling == 'm') {
                  return serieValue
                }
                return [ +moment.utc(v[0]).format('x'), serieValue ]
              })
            }

            series.push(serie)
          })

          data.parameters.forEach( (p, i) => {
            options.yaxis.push({
              seriesName: p.parameterName,
              opposite: true,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
              },
              title: {
                text: p.parameterName + ' ['+ p.mu +']'
              },
            })

            series.push({
              name: p.parameterName,
              type: 'line',
              data: data.values.map( v => {
                return [ +moment.utc(v[0]).format('x'), v[data.columns.length  +  i] ]
              })
            })
          })

          if(series.length > 1 && !this.split)
            options.chart.toolbar.tools.customIcons.push(_.cloneDeep(this.splitButton))

          if(this.split)
            options.chart.toolbar.tools.customIcons.push(_.cloneDeep(this.mergeButton))

          if(this.split) {
            data.columns.forEach( (c, i) => {
              if(i == 0)
                return;

              let seriesOptions = _.cloneDeep(options)
              seriesOptions.colors = [ this.colors[i % this.colors.length] ]

              seriesOptions.title = {
                style: {
                  fontSize: "22px"
                },
              }

              this.charts.push({
                title: c, options: seriesOptions, series: [series[i - 1]]
              })
            })
            // this.$toasted.show('Completato', { duration: 1000, icon : 'check', theme: "bubble" })
            this.$notify({
              type: "success",
              text: "Completato",
              title: 'Successo'
            }); 
          } else {
            this.charts.push({
              options, series
            })
          }
          this.show = true
        })
        .finally(() => {
          this.$store.commit("stopLoading");
        })
      }
    }
  },

  computed: {
    monthLabels() {
      return 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_')
    }
  },

  watch: {
    isNeedUpdate() {
      _.debounce(this.reload, 10)();
    },

    filter() {
      _.debounce(this.reload, 10)();
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Apex/Column.vue